import React, { useContext } from "react";
import { Box, Typography } from "@mui/material";
import CustomButton from "../../../UIElements/CustomButton";
import { LayoutBarContext } from "../../../../contexts";
import NewDossier from "../NewDossier/NewDossier";

type EmptyDossiersPropsType = {
    topLevelRefCode?: {
        refCodeNumber: number;
        finalized: boolean;
    };
};

export default function EmptyDossiers(props?: EmptyDossiersPropsType) {
    const { updateContent } = useContext(LayoutBarContext);

    const { topLevelRefCode } = props || {};

    const goToCreateNewDossier = () => {
        updateContent(<NewDossier topLevelRefCode={topLevelRefCode} />);
    };

    return (
        <Box
            sx={{
                display: "inline-flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "2rem",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "1.5rem",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "0.5rem",
                        alignSelf: "stretch",
                    }}
                >
                    <Typography
                        sx={{
                            color: "#023",

                            fontFamily: "Roboto",
                            fontSize: "1rem",
                            fontStyle: "normal",
                            fontWeight: 400,
                            lineHeight: "normal",
                        }}
                    >
                        Vous n’avez aucun dossier de qualification en cours.
                    </Typography>
                </Box>
            </Box>
            <CustomButton
                withoutendcon={true}
                hasstartaddicon={true}
                label="Créer un nouveau dossier"
                onClick={() => {
                    goToCreateNewDossier();
                }}
                customsx={{
                    margin: 0,
                }}
            />
        </Box>
    );
}
